import script from "./StepFinal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepFinal.vue?vue&type=script&setup=true&lang=ts"

import "./StepFinal.vue?vue&type=style&index=0&id=bc872b4a&lang=scss"

const __exports__ = script;

export default __exports__